export const toUrlObject = (urlLike: URL | string): URL => {
  if (urlLike instanceof URL) return urlLike;

  return new URL(urlLike, window.location.href);
};
